import React, { useEffect, useState } from "react";

const WORD = "MILLION THREADS";

export default function LoadingScreen({ onComplete }) {
  const [leaving, setLeaving] = useState(false);

  useEffect(() => {
    // Show loader once per full page load — not on internal SPA nav.
    const t = window.setTimeout(() => setLeaving(true), 2300);
    const t2 = window.setTimeout(() => onComplete && onComplete(), 3000);
    return () => { window.clearTimeout(t); window.clearTimeout(t2); };
  }, [onComplete]);

  return (
    <div className="mt-loader" role="status" aria-label="Loading Million Threads" data-testid="loading-screen">
      <div className="mt-loader-inner mt-loader-pulse">
        <div className="relative flex flex-col items-center gap-4">
          {/* Logo mark */}
          <img
            src="/logo.png"
            alt="Million Threads"
            style={{ width: 96, height: 96, objectFit: "contain", filter: "drop-shadow(0 0 20px rgba(0,170,255,0.35))" }}
          />
          <div className="mt-loader-word" aria-hidden="true">
            {WORD.split("").map((ch, i) => (
              <span
                key={i}
                className={`mt-loader-letter ${ch === " " ? "space" : ""}`}
                style={{ animationDelay: `${i * 55}ms` }}
              >
                {ch === " " ? "\u00A0" : ch}
              </span>
            ))}
          </div>
        
        </div>
        <div className="mt-loader-line" aria-hidden="true" />
        <p className="font-mono text-[0.62rem] tracking-mt uppercase mt-2" style={{ color: "rgba(255,255,255,0.45)" }}>
          Wear the Future.
        </p>
      </div>
    </div>
  );
}
